export type SemanticBrand<TValue, TBrand extends string> = TValue & {
  readonly __semanticBrand: TBrand;
};

export type RtkGlueAppId = SemanticBrand<string, 'RtkGlueAppId'>;
export type RtkGlueModuleId = SemanticBrand<string, 'RtkGlueModuleId'>;
export type SemanticRouteId = SemanticBrand<string, 'SemanticRouteId'>;
export type SemanticRoutePath = SemanticBrand<string, 'SemanticRoutePath'>;
export type SemanticPersona = SemanticBrand<string, 'SemanticPersona'>;
export type AppSyncMutationName = SemanticBrand<string, 'AppSyncMutationName'>;
export type AppSyncOperationName = SemanticBrand<string, 'AppSyncOperationName'>;
export type RtkSliceName = SemanticBrand<string, 'RtkSliceName'>;
export type RtkReducerPath = SemanticBrand<string, 'RtkReducerPath'>;
export type RtkEndpointName = SemanticBrand<string, 'RtkEndpointName'>;
export type RtkSelectorName = SemanticBrand<string, 'RtkSelectorName'>;
export type GeneratorContractName = SemanticBrand<string, 'GeneratorContractName'>;
export type DomainIntentName = SemanticBrand<string, 'DomainIntentName'>;

const requireNonEmptyString = (value: string, label: string): string => {
  const next = String(value ?? '').trim();
  if (!next) {
    throw new Error(`${label} must be a non-empty string.`);
  }
  return next;
};

const toSemanticBrand = <TBrand extends string>(
  value: string,
  label: string
): SemanticBrand<string, TBrand> => requireNonEmptyString(value, label) as SemanticBrand<string, TBrand>;

export const toRtkGlueAppId = (value: string): RtkGlueAppId => toSemanticBrand(value, 'appId');
export const toRtkGlueModuleId = (value: string): RtkGlueModuleId => toSemanticBrand(value, 'moduleId');
export const toSemanticRouteId = (value: string): SemanticRouteId => toSemanticBrand(value, 'routeId');
export const toSemanticRoutePath = (value: string): SemanticRoutePath => toSemanticBrand(value, 'semanticPath');
export const toSemanticPersona = (value: string): SemanticPersona => toSemanticBrand(value, 'persona');
export const toAppSyncMutationName = (value: string): AppSyncMutationName =>
  toSemanticBrand(value, 'mutationName');
export const toAppSyncOperationName = (value: string): AppSyncOperationName =>
  toSemanticBrand(value, 'graphqlOperationName');
export const toRtkSliceName = (value: string): RtkSliceName => toSemanticBrand(value, 'sliceName');
export const toRtkReducerPath = (value: string): RtkReducerPath => toSemanticBrand(value, 'reducerPath');
export const toRtkEndpointName = (value: string): RtkEndpointName => toSemanticBrand(value, 'endpointName');
export const toRtkSelectorName = (value: string): RtkSelectorName => toSemanticBrand(value, 'selectorName');
export const toGeneratorContractName = (value: string): GeneratorContractName =>
  toSemanticBrand(value, 'generatorName');
export const toDomainIntentName = (value: string): DomainIntentName => toSemanticBrand(value, 'domainIntent');

